import { render, staticRenderFns } from "./TextMarketingSettingsModal.vue?vue&type=template&id=0972b8f4&scoped=true"
import script from "./TextMarketingSettingsModal.vue?vue&type=script&lang=js"
export * from "./TextMarketingSettingsModal.vue?vue&type=script&lang=js"
import style0 from "./TextMarketingSettingsModal.vue?vue&type=style&index=0&id=0972b8f4&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0972b8f4",
  null
  
)

export default component.exports